import { CalendarDto } from "src/dtos/calendar/calendarDto";
import { ResponseDto } from "src/dtos/common/responseDto";
import config from "src/config";
import { getData, postData, patchData, deleteData } from "src/utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/SYS4110_R01`;

// 검색 조건 인터페이스
export interface CalendarSearchParams {
  compCd?: string;
  startDate?: string;
  endDate?: string;
  holidayYn?: string;
  holidayName?: string;
}

// API 응답 타입
export type CalendarListResponse = ResponseDto<CalendarDto[]>;
export type CalendarResponse = ResponseDto<CalendarDto>;
export type CalendarDeleteResponse = ResponseDto<void>;

/**
 * 캘린더 목록 조회 (GET) - 조건 검색
 * @param params 검색 조건
 * @returns 캘린더 목록 응답
 */
export const getCalendarList = async (params?: CalendarSearchParams) => {
  return await getData<CalendarListResponse>(baseUrl, params ? { params } : undefined);
};

/**
 * 캘린더 등록 (POST)
 * @param data 등록할 캘린더 데이터
 * @returns 등록된 캘린더 응답
 */
export const createCalendar = async (data: CalendarDto) => {
  return await postData<CalendarDto, CalendarResponse>(baseUrl, data);
};

/**
 * 캘린더 수정 (PATCH)
 * @param data 수정할 캘린더 데이터
 * @returns 수정된 캘린더 응답
 */
export const updateCalendar = async (data: CalendarDto) => {
  const { compCd, systemDay, ...updateData } = data;
  const url = `${baseUrl}?compCd=${compCd}&systemDay=${systemDay}`;
  return await patchData<Partial<CalendarDto>, CalendarResponse>(url, updateData);
};

/**
 * 캘린더 삭제 (DELETE)
 * @param compCd 회사 코드
 * @param calendarDt 캘린더 날짜 (백엔드 파라미터명에 맞춤)
 * @returns 삭제 응답
 */
export const deleteCalendar = async (compCd: string, calendarDt: string) => {
  const url = `${baseUrl}?compCd=${compCd}&calendarDt=${calendarDt}`;
  return await deleteData<CalendarDeleteResponse>(url);
}; 